<template lang="pug">
    div
        CheckboxGroup(:value="value" @on-change="onChange")
            // options 是 object, 有 label 和 value
            template(
                v-if="typeof options[0] == 'object'")
                Row(
                    v-for="option in options"
                    :key="option.label")
                    Checkbox(:label="option.value" :disabled="disabled")
                        span {{ option.label }}
            // options 是 value array
            template(v-else)
                Checkbox(
                    v-for="option in options"
                    :label="option"
                    :key="option"
                    :disabled="disabled")
        strong(v-if="options.length == 0") {{ formItem.noOptionsText }}
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    data() {
        return {
            options: this.formItem.options
        };
    },
    computed: {
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
    },
    methods: {
        onChange(val) {
            this.$emit("input", val);
            this.formItem.watchField(val, this.formData);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/CheckboxGroup.vue